import { Component, OnInit} from "@angular/core";
import { ActivatedRoute, Route, Params } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../../environments/environment";
import { DistributorIdFormatPipe } from "../../common/pipes/distributor-id-format.pipe";
import { CacheKey } from "../../shared/constants/cachekey.constants";
import { CommonConstant } from "../../shared/constants/common.constants";
import { CacheService } from "../../shared/services/cache.service";
import { TermsAndConditionsMsg } from "../constants/terms-and-conditions-messages.constants";
import { RetailSubscriptionValidationMessages } from "../interface/retail-subscription-history.interface";
import { RetailSubscriptionService } from "../services/retail-subscription.service";


@Component({
    selector: 'app-terms-and-condition',
    templateUrl: '../templates/template1/views/terms-and-condition.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/profile-info.less'
    ],
    providers: [DistributorIdFormatPipe]
})
export class TermsAndConditionComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private _translate: TranslateService,
        private retailSubscription: RetailSubscriptionService,
        private _cacheService: CacheService
    ) { }

    isTermsAndConditionAccepted: boolean = false;
    distributorId: string;
    languageCode: string;
    termsAndConditionPdfUrl = '';
    termsAndConditionDefaultPdf = CommonConstant.termsAndConditionDefaultPdf;
    termsAndConditionMessage: { msg: string, class: string, icon: string,isMobileView?:boolean } = { msg: "", class: "", icon: "",isMobileView:false };
    showTermsAndCondition: boolean = false;
    private _cookieService: CookieService = new CookieService(document);


    ngOnInit(): void {
        this.removeGuestToken(true);
        this.route.queryParams.skip(1).subscribe((params) => {
            if(params && params.distributorid && params.languagecode ){ 
            this.distributorId = params['distributorid'];
            this.languageCode = params['languagecode'];
                this.translate();
                this.getermsAndConditionDocument();
                this.guestToken();
            }
            else{
                let errMsg:RetailSubscriptionValidationMessages = { messages: '', value: false };
                errMsg.messages = TermsAndConditionsMsg.DISTRIBUTORID_OR_LanguageCode;
                errMsg.value = true
                this.errorMessages(errMsg);
                this.showTermsAndCondition = false;
            }            
        });
    }

    removeGuestToken(Guest:boolean) {
        if(Guest){
            this._cacheService.remove(CacheKey.guestToken);
        }
    }

    acceptTermsandCondition(event: any): void {
        this.isTermsAndConditionAccepted = event.currentTarget.checked;
    }


    translate(): void {
        if (this.languageCode != null && this.languageCode != undefined) {
            const languageCode: any = {
                code: this.languageCode,
                isChargebeeLanguage: true
            }
            this._translate.use(languageCode);
        }
    }

    submitTermsandCondtion(): void {
        if (this.isTermsAndConditionAccepted) {
            this.removeGuestToken(false);
            this.retailSubscription.updateTermsandCondition(this.distributorId).subscribe(res => {
                if (res && res.validations && res.validations.length == 0 && res.isSuccess) {
                    this.showTermsAndCondition = false;
                    const successMessage = (this._translate.get('terms-and-condition.Thank you for accepting the FLP Shared Retail Subscription Terms and Conditions.') as any);
                    this.termsAndConditionMessage.msg = successMessage ? successMessage.value : TermsAndConditionsMsg.SUCCESS_MESSAGE;
                    this.termsAndConditionMessage.class = TermsAndConditionsMsg.SUCCESS_CLASS;
                    this.termsAndConditionMessage.icon = TermsAndConditionsMsg.CHECK_ICON;
                }
                else {
                    this.showTermsAndCondition = false;
                    this.errorMessages();
                }
            }, error => {
                this.showTermsAndCondition = false;
                this.errorMessages();
            })
        }
    }

    errorMessages(errMsg?:any) {
        let failureMessage = (this._translate.get('terms-and-condition.An FLP Shared Retail Subscription Terms and Conditions error occurred.') as any).value;
        this.termsAndConditionMessage.msg = failureMessage ? failureMessage : TermsAndConditionsMsg.FAILURE_MESSAGE;
        this.termsAndConditionMessage.class = TermsAndConditionsMsg.DANGER_CLASS;
        this.termsAndConditionMessage.icon = TermsAndConditionsMsg.CLOSE_ICON;
        if(errMsg && errMsg.value){
            if(errMsg.messages == TermsAndConditionsMsg.DISTRIBUTORID_OR_LanguageCode){
                this.termsAndConditionMessage.msg =  TermsAndConditionsMsg.UNEXPECTED_MESSAGE;
            }
            else if(errMsg.messages == TermsAndConditionsMsg.EXPIRED_LINK){
                failureMessage = (this._translate.get('terms-and-condition.Sorry the link you are trying to access is expired If you have any questions please contact customer care') as any).value;
                this.termsAndConditionMessage.msg = failureMessage ? failureMessage : TermsAndConditionsMsg.EXPIRED_LINK_MESSAGE;
            }            
        }
        this.termsAndConditionMessage.isMobileView = this.checkBrowserView();
    }

    getermsAndConditionDocument() {
        if (this.languageCode) {
            this.retailSubscription.getTermAndConditonPdf(this.languageCode.toLowerCase()).subscribe(response => {
                if (response) {
                    const responseurl = response.url;
                    this.termsAndConditionPdfUrl = responseurl;
                    this.updateTermsAndConditionPdf();
                } else {
                    this.termsAndConditionPdfUrl = environment.cdnURL + this.termsAndConditionDefaultPdf;
                    this.updateTermsAndConditionPdf();
                }
            },
                error => {
                    this.termsAndConditionPdfUrl = environment.cdnURL + this.termsAndConditionDefaultPdf;
                    this.updateTermsAndConditionPdf();
                });
        }
    }

    updateTermsAndConditionPdf() {
        setTimeout(()=>{
        const element = document.getElementById('termsAndConditionLink');
        if (element) {
            element.setAttribute('href', this.termsAndConditionPdfUrl);
            element.setAttribute('target', '_blank')
        }
    },0)
    }

    guestToken() {
        this.retailSubscription.getGuestToken().subscribe((response) => {
            if (response && response.guestToken) {
                const guestToken = response.guestToken
                if (guestToken) {
                    this._cacheService.set(CacheKey.guestToken, guestToken);
                    this.checkTermsAndCondition(this.distributorId)
                }
            }
            else {
                this.showTermsAndCondition = false;
                this.errorMessages();
            }
        },err=>{
            this.showTermsAndCondition = false;
            this.errorMessages();
        });
    }

    checkTermsAndCondition(distributorID: string) {
        if (distributorID) {
            this.retailSubscription.checkingTermsAndConditionAccepted(distributorID).subscribe(res => {
                if (res && res.isSuccess) {
                    this.showTermsAndCondition = false;
                    const successMessage = (this._translate.get('terms-and-condition.You have already accepted the FLP Shared Retail Subscription Terms and Conditions.') as any);
                    this.termsAndConditionMessage.msg = successMessage ? successMessage.value : TermsAndConditionsMsg.ACCEPTED_MESSAGE;
                    this.termsAndConditionMessage.class = TermsAndConditionsMsg.SUCCESS_CLASS;
                    this.termsAndConditionMessage.icon = TermsAndConditionsMsg.CHECK_ICON;
                    this.termsAndConditionMessage.isMobileView = this.checkBrowserView();
                }
                else if(!res.isSuccess && res.validations && res.validations.length>0){
                    let errMsg: RetailSubscriptionValidationMessages = { messages: '', value: false };
                    for(let i=0;i<res.validations.length;i++){
                    if(res.validations[i].name && res.validations[i].name.toLowerCase() == TermsAndConditionsMsg.EXPIRED_LINK.toLowerCase()){
                            errMsg.messages = TermsAndConditionsMsg.EXPIRED_LINK;
                            errMsg.value = true                                                         
                    }
                }
                    this.errorMessages(errMsg);
                    this.showTermsAndCondition = false;                   
                }
                else {
                    this.termsAndConditionMessage.isMobileView = this.checkBrowserView();
                    this.showTermsAndCondition = true;
                    this.updateTermsAndConditionPdf()
                }

            }, err => {
                this.showTermsAndCondition = false;
                this.errorMessages();
            })
        }
    }

    checkBrowserView() {
        const width = window.screen.width;
        if (width && width < 600) return true;
        return false
    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/terms-and-condition.component.ts